import { useGetAllBatchByTrainerIdCourseId } from "../../../assets/nodeApi/getApi/getAdminApi";



export const useBatchNodeOptions = (TrainerId,CourseId) => {
    
    const { data: batchForCourseList, isLoading: isBatchForCourseLoading } = useGetAllBatchByTrainerIdCourseId(CourseId,{trainerId:TrainerId})
    const BatchOptionsForCourse = batchForCourseList?.data?.map((item, index) => ({
        id: item?.id,
        sr_no: index + 1,
        label: item?.batch_name,
        value: item?.batch_name,
        ...item
    }));

    return {
        BatchForCourse: {
            options: BatchOptionsForCourse,
            isLoading: isBatchForCourseLoading
        }
    };
};
